import { render } from "./TheMain.vue?vue&type=template&id=2673e84d&scoped=true"
import script from "./TheMain.vue?vue&type=script&lang=js"
export * from "./TheMain.vue?vue&type=script&lang=js"

import "./TheMain.vue?vue&type=style&index=0&id=2673e84d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2673e84d"]])

export default __exports__